import CIMSComment from 'components/CIMSComment'
import CIMSFormItem from 'components/CIMSFormItem'
import ExternalLinkEditor from 'components/ExternalLinkEditor'
import { useIssueTrackerContext } from '../../../../IssueTrackerContext'
import SharePointUploader from 'components/SharePointUploader'
import { Issue } from '../../../../IssueTrackerContext/types'
import { SharePointParentFolder } from '@cims-online/shared'
import { useGenericComment } from 'components/CIMSComment/hooks/useGenericComment'

const CommonFormItemValues: React.FC<Issue> = ({ number }) => {
  const { quickLinkOptions } = useIssueTrackerContext()
  return (
    <>
      <CIMSFormItem {...useGenericComment()}>
        <CIMSComment />
      </CIMSFormItem>
      <SharePointUploader
        folder={number.toString()}
        parent={SharePointParentFolder.Issues}
      />
      <ExternalLinkEditor quickLinkOptions={quickLinkOptions} />
    </>
  )
}

export default CommonFormItemValues
